import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Calendar as CalendarIcon, Clock, User, Mail, Phone } from 'lucide-react';
export function ScheduleTour() {
  const [selectedDate, setSelectedDate] = useState<number | null>(null);
  const [selectedTime, setSelectedTime] = useState<string | null>(null);
  // Simple placeholder dates for the UI
  const dates = Array.from({
    length: 7
  }, (_, i) => {
    const d = new Date();
    d.setDate(d.getDate() + i + 1);
    return {
      day: d.toLocaleDateString('en-US', {
        weekday: 'short'
      }),
      date: d.getDate(),
      full: d
    };
  });
  const times = ['10:00 AM', '11:30 AM', '1:00 PM', '2:30 PM', '4:00 PM'];
  return <section id="schedule" className="py-24 md:py-32 bg-stone-deep text-cream" data-id="element-80">
      <div className="max-w-6xl mx-auto px-6 md:px-12" data-id="element-81">
        <div className="text-center mb-16" data-id="element-82">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl lg:text-6xl font-serif mb-6" data-id="element-83">
            Ready to Experience <br className="hidden md:block" data-id="element-84" /> North
            Scottsdale Living?
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-sand text-lg md:text-xl" data-id="element-85">
            Tours available by appointment. Private showings welcome.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-24 items-start" data-id="element-86">
          {/* Calendar Widget Placeholder */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3
        }} className="bg-cream text-stone-deep rounded-2xl p-8 md:p-10" data-id="element-87">
            <div className="mb-8" data-id="element-88">
              <h3 className="text-xl font-serif font-semibold mb-6 flex items-center gap-2" data-id="element-89">
                <CalendarIcon className="text-brown" size={20} data-id="element-90" />
                Select a Date
              </h3>
              <div className="flex gap-3 overflow-x-auto pb-4 scrollbar-hide" data-id="element-91">
                {dates.map((d, i) => <button key={i} onClick={() => setSelectedDate(i)} className={`flex-shrink-0 w-16 h-20 rounded-xl border flex flex-col items-center justify-center transition-all duration-200 ${selectedDate === i ? 'bg-brown border-brown text-cream' : 'border-sand/40 hover:border-brown'}`} data-id="element-92">
                    <span className="text-xs uppercase tracking-wider mb-1 opacity-80" data-id="element-93">
                      {d.day}
                    </span>
                    <span className="text-xl font-serif font-semibold" data-id="element-94">
                      {d.date}
                    </span>
                  </button>)}
              </div>
            </div>

            <div className="mb-8" data-id="element-95">
              <h3 className="text-xl font-serif font-semibold mb-6 flex items-center gap-2" data-id="element-96">
                <Clock className="text-brown" size={20} data-id="element-97" />
                Select a Time
              </h3>
              <div className="grid grid-cols-2 sm:grid-cols-3 gap-3" data-id="element-98">
                {times.map((time, i) => <button key={i} onClick={() => setSelectedTime(time)} className={`py-3 rounded-xl border text-sm transition-all duration-200 ${selectedTime === time ? 'bg-brown border-brown text-cream' : 'border-sand/40 hover:border-brown'}`} data-id="element-99">
                    {time}
                  </button>)}
              </div>
            </div>
          </motion.div>

          {/* Form */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4
        }} className="flex flex-col space-y-6" data-id="element-100">
            <div className="space-y-4" data-id="element-101">
              <div className="relative" data-id="element-102">
                <User className="absolute left-4 top-1/2 -translate-y-1/2 text-cream/50" size={20} data-id="element-103" />
                <input type="text" placeholder="Full Name" className="w-full bg-transparent border border-cream/20 rounded-xl py-4 pl-12 pr-4 text-cream placeholder:text-cream/50 focus:outline-none focus:border-sand transition-colors" data-id="element-104" />
              </div>
              <div className="relative" data-id="element-105">
                <Mail className="absolute left-4 top-1/2 -translate-y-1/2 text-cream/50" size={20} data-id="element-106" />
                <input type="email" placeholder="Email Address" className="w-full bg-transparent border border-cream/20 rounded-xl py-4 pl-12 pr-4 text-cream placeholder:text-cream/50 focus:outline-none focus:border-sand transition-colors" data-id="element-107" />
              </div>
              <div className="relative" data-id="element-108">
                <Phone className="absolute left-4 top-1/2 -translate-y-1/2 text-cream/50" size={20} data-id="element-109" />
                <input type="tel" placeholder="Phone Number" className="w-full bg-transparent border border-cream/20 rounded-xl py-4 pl-12 pr-4 text-cream placeholder:text-cream/50 focus:outline-none focus:border-sand transition-colors" data-id="element-110" />
              </div>
            </div>

            <button className="w-full bg-sand text-stone-deep py-4 rounded-xl uppercase tracking-widest font-medium hover:bg-cream transition-colors duration-300 mt-4" data-id="element-111">
              Book My Tour
            </button>
            <p className="text-center text-cream/50 text-sm mt-4" data-id="element-112">
              By submitting, you agree to be contacted regarding this property.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}